<template>
    <div class="hidden">
        <img
            v-if="item && item.image && !item.video"
            :srcset="imageSrcset"
            :src="prefetchSrc"
            crossorigin="anonymous"
            width="1"
            height="1"
        />
        <img
            v-if="item && item.video"
            :src="prefetchVideoThumbnail"
            crossorigin="anonymous"
            width="1"
            height="1"
        />
    </div>
</template>

<script>
import {
    getImageUrl,
    getImageSrcset,
    getVideoThumbnailUrl
} from '@/services/image.service';

export default {
    name: 'ImagePrefetcher',
    props: {
        item: {
            type: Object,
            required: true
        },
        isTwoColumnLayout: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        prefetchSrc() {
            return getImageUrl(this.item.image, this.isTwoColumnLayout);
        },
        imageSrcset() {
            return getImageSrcset(this.item.image, this.isTwoColumnLayout);
        },
        prefetchVideoThumbnail() {
            return getVideoThumbnailUrl(this.item.video);
        }
    }
};
</script>
